import "./actividad.css";
import { Box, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { IaxRoundButton } from "../UIComponents/IaxRoundButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import { Button } from "@mui/material";
import {
  checkFechaPasada,
  esEditable,
  formatearFecha,
  imageUrl,
  isEmpty,
  recortarTexto,
  userIsAdmin,
  validActProfeComentable,
} from "../../util/Functions";
import { useNavigate } from "react-router-dom";
import { getUserLoggedLS } from "../../util/LocalStorageUtils";
import { deleteActividad, updateActividad } from "./Actividades-Api";
import { IaxAlertDialog } from "../UIComponents/IaxAlertDialog";
import { useEffect, useRef, useState } from "react";
import IaxValoracionDialog from "../UIComponents/IaxValoracionDialog";
import AddPhotoAlternateRoundedIcon from "@mui/icons-material/AddPhotoAlternateRounded";
import ImageUploadDialog from "../UIComponents/ImageUploadDialog";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import IaxGroupSelectorDialog from "../UIComponents/IaxGroupSelectorDialog";
import IaxGroupSummary from "../UIComponents/IaxGroupSummary";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const Img = styled("img")({
  width: "100%",
  maxHeight: "400px",
  height: "auto",
  objectFit: "contain", // evita recortes laterales
  objectPosition: "center",
  paddingLeft: "10px",
  paddingRight: "10px",
});

export function Actividad({ act, setTitulo, refrescar, notificar }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [ratingOpen, setRatingOpen] = useState(false);
  const [uploadImageOpen, setUploadImageOpen] = useState(false);
  const [deactivateOpen, setDeactivateOpen] = useState(false);
  const [groupOpen, setGroupOpen] = useState(false);
  const [overflowDesc, setOverflowDesc] = useState(false);
  const [showDesc, setShowDesc] = useState(false);
  const descRef = useRef(null);

  useEffect(() => {
    const el = descRef.current;
    if (!el) return;

    const measure = () => setOverflowDesc(el.scrollHeight - el.clientHeight > 1);

    // medir tras el pintado
    requestAnimationFrame(measure);

    // volver a medir en cambios de tamaño / reflow
    const resizeObserver = new ResizeObserver(() => measure());
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, [act.descripcion]);

  const handleConsultaValoracion = (act) => {
    let _userLogged = getUserLoggedLS();
    if (
      _userLogged != null &&
      (userIsAdmin(_userLogged) || act.profesorResponsable.id == _userLogged.id)
    ) {
      handleOpenRatingDialog(act);
    }
  };

  // control invertir activado
  const handleInvierteActivado = () => {
    if (userIsAdmin(getUserLoggedLS())) {
      if (!act.activado) {
        invierteActividado();
      } else {
        setDeactivateOpen(true);
      }
    }
  };

  const invierteActividado = () => {
    act.activado = !act?.activado;
    updateActividad(act, alTerminar);
  };

  const alTerminar = (act) => {
    const msg = act?.activado
      ? "Actividad validada con éxito!"
      : "Actividad invalidada!";
    notificar(msg);
    refrescar();
  };

  const handleCloseDeactivate = () => {
    setDeactivateOpen(false);
  };
  const handleConfirmDeactivate = () => {
    setDeactivateOpen(false);
    invierteActividado();
  };

  let color;
  let textoBoton;
  let clickaction = handleInvierteActivado;

  // De cualquier forma, si nos encontramos act.archivada 
  // se marca como archivada independientemente de que esté
  // activada, valorada o lo que sea.
  if (act.archivada) {
    color = "secondary";
    textoBoton = "Archivada";
    clickaction = handleConsultaValoracion;
  } else if (act.activado) {
    if (!act.valorado) {
      color = "info";
      textoBoton = "Validada";
      if (checkFechaPasada(act.fechaFin)) {
        color = "warning";
        textoBoton += " - Pdte. valoración";
      }
    } else if (!act.archivada){
      color = "success";
      textoBoton = "Valorada";
      clickaction = handleConsultaValoracion;
    } 
  } else {
    color = "error";
    textoBoton = "Sin Validar";
  }  

  var userLogged = getUserLoggedLS();

  let button = !isEmpty(userLogged) ? (
    <Button variant="contained" color={color} onClick={() => clickaction(act)}>
      {textoBoton}
    </Button>
  ) : (
    ""
  );

  let profresp = "";
  if (act.profesorResponsable != null) {
    profresp =  act.profesorResponsable?.nombre + " " + act.profesorResponsable?.apellidos;
  }

  let profsacomp1 = "";
  if (act.profesorAcomp1 != null) {
    profsacomp1 =
      "Acompañante/s: " +
      act.profesorAcomp1?.nombre +
      " " +
      act.profesorAcomp1?.apellidos;
  }
  let profsacomp2 = "";
  if (act.profesorAcomp2 != null) {
    profsacomp2 =
      ", " + act.profesorAcomp2?.nombre + " " + act.profesorAcomp2?.apellidos;
  }
  let profsacomp3 = "";
  if (act.profesorAcomp3 != null) {
    profsacomp3 =
      ", " + act.profesorAcomp3?.nombre + " " + act.profesorAcomp3?.apellidos;
  }
  let profsacomp4 = "";
  if (act.profesorAcomp4 != null) {
    profsacomp4 =
      ", " + act.profesorAcomp4?.nombre + " " + act.profesorAcomp4?.apellidos;
  }
  let profsacomp5 = "";
  if (act.profesorAcomp5 != null) {
    profsacomp5 =
      ", " + act.profesorAcomp5?.nombre + " " + act.profesorAcomp5?.apellidos;
  }

  const fechaInicioStr = formatearFecha(act.fechaInicio);
  const fechaFinStr = formatearFecha(act.fechaFin);
  const horaInicioStr = act.horaInicio ?? "";
  const horaFinStr = act.horaFin ?? "";
  const mismaFecha =
    act.fechaInicio &&
    act.fechaFin &&
    new Date(act.fechaInicio).toDateString() ===
      new Date(act.fechaFin).toDateString();
  const rangoHoras =
    horaInicioStr && horaFinStr
      ? `${horaInicioStr} - ${horaFinStr}`
      : horaInicioStr || horaFinStr || "";
  const fechaEnLinea = `${fechaInicioStr}${rangoHoras ? " " + rangoHoras : ""}`;

  let _userLogged = getUserLoggedLS();
  const isLogged = !isEmpty(_userLogged);
  let editable = esEditable(_userLogged, act);
  let editButton = editable ? (
    <IaxRoundButton onClick={() => handleEdit(act)}>
      <EditRoundedIcon
        sx={{
          alignSelf: "center",
          color: "white",
          textAlign: "center",
        }}
      />
    </IaxRoundButton>
  ) : (
    ""
  );

  // control de subida de imagen
  const handleOpenUploadImageDialog = () => {
    setUploadImageOpen(true);
  };
  const handleCloseUploadImageDialog = () => {
    setUploadImageOpen(false);
    refrescar();
  };

  let uploadImageButton = editable ? (
    <IaxRoundButton onClick={() => handleOpenUploadImageDialog(act)}>
      <AddPhotoAlternateRoundedIcon
        sx={{
          alignSelf: "center",
          color: "white",
          textAlign: "center",
        }}
      />
    </IaxRoundButton>
  ) : (
    ""
  );

  // control selector de grupos
  const handleOpenGroupSelectorDialog = () => {
    setGroupOpen(true);
  };
  const handleCloseGroupSelectorDialog = () => {
    setGroupOpen(false);
    refrescar();
  };

  let groupSelectorButton = editable ? (
    <IaxRoundButton onClick={() => handleOpenGroupSelectorDialog()}>
      <GroupRoundedIcon
        sx={{
          alignSelf: "center",
          color: "white",
          textAlign: "center",
        }}
      />
    </IaxRoundButton>
  ) : (
    ""
  );

  // control borrado
  const handleDelete = (act) => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirmAction = () => {
    setOpen(false);
    deleteActividad(act, alTerminarBorrado);
  };
  const alTerminarBorrado = (act) => {
    const msg = "Actividad eliminada!";
    notificar(msg);
    refrescar();
  };
  // https://www.youtube.com/watch?v=_Rz2p3rjBvY
  let eraseButton = editable ? (
    <IaxRoundButton onClick={() => handleDelete(act)}>
      <DeleteForeverRoundedIcon
        sx={{
          alignSelf: "center",
          color: "red",
          textAlign: "center",
        }}
      />
    </IaxRoundButton>
  ) : (
    ""
  );

  let closed = act.archivada == true;
  let lockUnlockButton = userIsAdmin(_userLogged) ? (
    <IaxRoundButton>
      {closed ? (
        <LockRoundedIcon
          sx={{
            alignSelf: "center",
            color: "purple",
            textAlign: "center",
          }}
        />
      ) : (
        <LockOpenRoundedIcon
          sx={{
            alignSelf: "center",
            color: "greenyellow",
            textAlign: "center",
          }}
        />
      )}
    </IaxRoundButton>
  ) : (
    ""
  );

  // control de valoración
  const handleOpenRatingDialog = () => {
    setRatingOpen(true);
  };
  const handleCloseRatingDialog = () => {
    setRatingOpen(false);
    refrescar();
  };
  let commentButton = validActProfeComentable(act, _userLogged) ? (
    <IaxRoundButton onClick={() => handleOpenRatingDialog(act)}>
      <CommentRoundedIcon
        sx={{
          alignSelf: "center",
          color: "lightblue",
          textAlign: "center",
        }}
      />
    </IaxRoundButton>
  ) : (
    ""
  );

  const handleEdit = (act) => {
    setTitulo("Editar actividad");
    navigate("/editactividad/" + act.id);
  };

  return (
    <Paper
      sx={{
        display: "flex",
        backgroundColor: "#f0f0f0",
        flexDirection: "column",
        verticalAlign: "top",
        justifyContent: "flex-start",
        borderRadius: "16px",
        gap: 1,
        overflow: "visible",
        height: "100%",
        flex: 1,
        width: "100%",
        minHeight: "900px",
        mt: 1,
        fontFamily: '"Roboto", "Helvetica Neue", Arial, sans-serif',
        fontSize: "0.95rem",
        lineHeight: 1.4,
        //"& h2, & h3, & p": { fontFamily: "inherit", marginTop: "0.35em" }
      }}
    >
      {button}
      <Img
        src={imageUrl(act.imagen)}
        alt=""
        sx={{
          paddingTop: isLogged ? 0 : "10px",
          borderRadius: isLogged ? 0 : "16px 16px 0 0",
        }}
      />
      <Box sx={{ flexGrow: 1, paddingLeft: "10px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
            mb: 1,
          }}
        >
          {editButton}
          {eraseButton}
          {lockUnlockButton}
          {commentButton}
          {uploadImageButton}
          {groupSelectorButton}
        </Box>
        <h2 className="h1_titulo">{recortarTexto(act.titulo, 70)}</h2>
        <h3 className="h3_lugar">{act.lugar}</h3>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: 2,
            textAlign: "center",
          }}
        >
          {mismaFecha ? (
            <Box>
              <h3
                className="h3_fechainicio"
                style={{ whiteSpace: "nowrap", marginTop: 0, marginBottom: 0 }}
              >
                {fechaEnLinea}
              </h3>
            </Box>
          ) : (
            <>
              <Box>
                <p className="label_fecha">Salida</p>
                <h3
                  className="h3_fechainicio"
                  style={{ whiteSpace: "nowrap", marginTop: 0 }}
                >
                  {fechaInicioStr}
                </h3>
                <h3 className="h3_fechainicio" style={{ marginTop: 2 }}>
                  {horaInicioStr ?? ""}
                </h3>
              </Box>
              <Box>
                <p className="label_fecha">Llegada</p>
                <h3
                  className="h3_fechainicio"
                  style={{ whiteSpace: "nowrap", marginTop: 0 }}
                >
                  {fechaFinStr}
                </h3>
                <h3 className="h3_fechainicio" style={{ marginTop: 2 }}>
                  {horaFinStr ?? ""}
                </h3>
              </Box>
            </>
          )}
        </Box>
        <p ref={descRef} className="p_descripcion">
          {act.descripcion ?? ""}
        </p>
        {overflowDesc && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mr: 2 }}>
            <Button size="small" onClick={() => setShowDesc(true)}>
              Ver más
            </Button>
          </Box>
        )}
        <IaxGroupSummary groups={act.grupos} />

        <p className="h3_proferesp">
          P.Responsable: {profresp}
          <br />
          {profsacomp1}
          {profsacomp2}
          {profsacomp3}
          {profsacomp4}
          {profsacomp5}
        </p>
      </Box>

      <IaxAlertDialog
        open={open}
        handleClose={handleClose}
        handleConfirmAction={handleConfirmAction}
        dialog_title="Eliminar actividad"
        dialog_msg={
          "¿Estás seguro de eliminar la actividad " + act.titulo + "?"
        }
      />
      <IaxValoracionDialog
        open={ratingOpen}
        onClose={handleCloseRatingDialog}
        actividad={act}
      />
      <ImageUploadDialog
        open={uploadImageOpen}
        onClose={handleCloseUploadImageDialog}
        idactividad={act.id}
      />
      <Dialog
        open={showDesc}
        onClose={() => setShowDesc(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{act.titulo ?? "Descripción"}</DialogTitle>
        <DialogContent dividers>
          <p className="p_descripcion_modal">{act.descripcion ?? ""}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDesc(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <IaxAlertDialog
        open={deactivateOpen}
        handleClose={handleCloseDeactivate}
        handleConfirmAction={handleConfirmDeactivate}
        dialog_title="Invalidar actividad"
        dialog_msg={
          "¿Estás seguro de invalidar la actividad " + act.titulo + "?"
        }
      />
      <IaxGroupSelectorDialog
        open={groupOpen}
        onClose={handleCloseGroupSelectorDialog}
        act={act}
      />
    </Paper>
  );
}
